module.exports = __webpack_public_path__ + "static/fancy-weather-cover-74d79fd8bc445ca4cde192f6e847e97c.jpg";